import * as actionTypes from '../actionTypes/careerPath';

export default {
  updateGeneratedData: (params) => ({
    type: actionTypes.UPDATE_CARER_PATH_DATA,
    payload: params,
  }),
};
